import { render, staticRenderFns } from "./GarageDoor.vue?vue&type=template&id=f672b798&scoped=true"
import script from "./GarageDoor.vue?vue&type=script&lang=ts"
export * from "./GarageDoor.vue?vue&type=script&lang=ts"
import style0 from "./GarageDoor.vue?vue&type=style&index=0&id=f672b798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f672b798",
  null
  
)

export default component.exports